export const oneSignal = () => {
    (window as any).OneSignal = (window as any).OneSignal || [];
    return (window as any).OneSignal;
};

export const oneSignalPlugin = () => (window as any).plugins.OneSignal;
